import { useMemo } from 'react'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import { useApplicationSettings } from 'hooks/usePageConfig'
import generateSentimentsStrategy from 'utils/insightModal/strategy/widgetSettingComposing/sentimentsStrategy'

const useWidgetSettingComposingStrategy = (viewOption: InsightViewOptionStrings) => {
  const applicationSettings = useApplicationSettings()
  const widgetSettingComposingStrategy = useMemo(() => {
    switch (viewOption) {
      case InsightViewOption.POSITIVE_NEGATIVE:
      case InsightViewOption.POSITIVE_NEGATIVE_NEUTRAL:
        return generateSentimentsStrategy(applicationSettings)
      default:
        throw new Error(`Unsupported view option: ${viewOption}`)
    }
  }, [viewOption, applicationSettings])

  return widgetSettingComposingStrategy
}

export default useWidgetSettingComposingStrategy
